<template>
  <div class="page scroll-wrapper">
    <header class="header bg-white w-full box-border">
      <div class="inner-container flex items-center justify-between">
        <img src="@/assets/home/logo.svg" alt="">
        <nav class="flex items-center">
          <div class="nav-item mx-4 cursor-pointer text-base px-1"
               :class="{'current': menuIndex === index}"
               v-for="(item, index) in menu" :key="index"
               @click="scrollToSec(item, index)">{{item.label }}</div>
        </nav>
      </div>
    </header>
    <Banner />
<!--    <div class="banner">-->
<!--      <Banner />-->
<!--&lt;!&ndash;      <img v-lazy="require('@/assets/home/banner-2.jpg')" style="height: 650px;object-fit: cover;">&ndash;&gt;-->
<!--    </div>-->
    <!--    首页-->
    <div id="home">
      <section id="home-sec-1">
        <div class="inner-container flex items-center justify-between">
          <img id="home-sec-1-cover" class="cover from" v-lazy="require('@/assets/home/home-cover-1.png')">
          <div class="info pl-12 flex-1 flex flex-col justify-between">
            <h3 id="home-sec-1-title" class="heading-1 from">中药材7S数字化产地仓</h3>
            <div id="home-sec-1-desc" class="desc from leading-6 my-6">7S中药材产地仓，是以7S第三方质量控制与评价体系为依托，构建道地药材生产技术体系和质量控制体系，在道地药材产区，联合产区政府、企业，共同创新推出“七统一两集中”中药材产地仓公共服务模式，以实现高品质药材提质、稳供为目的。打造一批种植规范化、产品标准化生产基地，形成品种集群化的一站式供应服务，满足医保集采、经典名方生产、品牌中医馆、品牌连锁药店、智慧煎药中心、出口等企业对高品质药材的需要，实现中药材产业提质增效，以产业振兴推动乡村振兴。</div>
            <ul id="home-sec-1-tags" class="flex from tag-list">
              <li class="flex flex-col items-center">
                <RedIcon icon="home-icon-1.svg"/>
                <div class="label mt-4">规范化种植</div>
              </li>
              <li class="flex flex-col items-center">
                <RedIcon icon="home-icon-2.svg" />
                <div class="label mt-4">集约化加工</div>
              </li>
              <li class="flex flex-col items-center">
                <RedIcon icon="home-icon-3.svg" />
                <div class="label mt-4">电子化交易</div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="home-sec-2">
        <div class="inner-container flex flex-col items-center justify-center">
          <h3 id="home-sec-2-title" class="heading-1 mb-8 text-center from">中药材 7S 数字化产地仓公共服务平台<br>(7S 产地仓数字化管理平台)架构图</h3>
          <img id="home-sec-2-cover" class="from" style="width: 1280px;" v-lazy="require('@/assets/home/home-cover-2.png')">
        </div>
      </section>
    </div>
    <!--    数字药园-->
    <div id="park">
      <section id="park-sec-1">
        <div class="inner-container flex flex-col justify-center">
          <h3 id="park-sec-1-title" class="heading-2 mb-10 from">数字药园</h3>
          <div class="flex">
            <ul id="park-sec-1-block-1" class="park-list from">
              <li v-for="(item, index) in parkList" :key="index" class="p-6 mb-5 cursor-pointer"
                  :class="{'current': currentParkIndex === index}"
                  @mouseenter="currentParkIndex = index">
                <h4 class="mb-4 transition">{{ item.title }}</h4>
                <p class="desc">{{ item.desc }}</p>
              </li>
            </ul>
            <div id="park-sec-1-block-2" class="flex justify-center from h-full" style="width: 670px;">
              <div class="change-container w-full overflow-hidden" style="width: 670px;height: 560px;">
                <div class="change-scroll-list flex flex-col transition ease-in-out duration-500"
                     :style="{transform: `translateY(${ currentParkIndex * -560 }px)`}">
                  <div v-for="(item, index) in parkList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                       :class="{'opacity-100': currentParkIndex === index}"
                       :key="index" style="width:670px;height: 560px;">
                    <img :src="item.cover"
                         class="w-full h-full"
                         style="object-fit: contain;">
                  </div>
                </div>
              </div>
<!--              <img v-lazy="parkList[currentParkIndex].cover" style="object-fit: contain">-->
            </div>
          </div>
        </div>
      </section>
      <section id="park-sec-2">
        <div class="inner-container flex items-center justify-center relative">
          <h3 id="park-sec-2-title" class="heading-2 absolute left-0 from" style="top: 70px;">数字药园-<span class="red-text">数字基地全景图</span></h3>
          <img id="park-sec-2-cover" class="from" v-lazy="require('@/assets/home/park-cover-1.png')" style="width: 1014px;">
        </div>
      </section>
      <section id="park-sec-3" class="relative overflow-hidden bg-section">
        <div class="inner-container flex flex-col items-center justify-center relative">
          <h3 id="park-sec-3-title" class="heading-2 text-center text-white from">数字药园—中药材全产业链溯源</h3>
          <p id="park-sec-3-desc" class="desc text-center my-8 from">“中药追溯”中药材全产业链区块链溯源采用区块链技术为中药材建立“身份证”制度，向前延申到原料供应商的种植基地，向后延展到加工产品销售，动态采集基于区块链的覆盖种植、农作、采摘、包装、仓储、运输、产地加工、流通、收储、精深加工、流通、销售等全产业链的溯源信息，溯源信息经7S质控审核后，上链发布。</p>
          <img id="park-sec-3-cover" v-lazy="require('@/assets/home/park-cover-2.png')" class="from" style="width: 854px;">
        </div>
      </section>
    </div>
    <!--    数字工厂-->
    <div id="factory">
      <section id="factory-sec-1" class="relative overflow-hidden bg-section">
        <div class="inner-container flex items-center">
          <div id="factory-sec-1-block-1" class="from" style="width:688px;">
            <Macbook>
              <CuzSwiper :swiperPages="factorySwiperPages"/>
            </Macbook>
          </div>
          <div class="flex-1 box-border" style="padding-left: 60px;">
            <h3 id="factory-sec-1-block-2" class="heading-2 from" style="margin-bottom: 56px;">数字工厂</h3>
            <ul id="factory-sec-1-block-3" class="factory-list from">
              <li v-for="(item, index) in factoryList" :key="index">
                <div class="flex mb-4 items-center">
                  <RedIcon :icon="item.icon"/>
                  <h4 class="ml-4">{{item.title}}</h4>
                </div>
                <p>{{item.desc}}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <!--    数字交易-->
    <div id="trade">
      <section id="trade-sec-1">
        <div class="inner-container flex flex-col justify-center items-center">
          <h3 id="trade-sec-1-title" class="heading-1 mb-8 from">数字交易</h3>
          <p id="trade-sec-1-desc" class="desc text-center from" style="width: 960px;">建立数字化交易平台，集群千乡万社数字化产地仓的标准化产品，开展订药园和中药材集采集供的电子化交易服务，为国家医保联采提供保障质量的药材原料，同时满足中药企业、医馆、连锁药店、煎药中心、出口等企业对高品质药材的集采需要，实现产销一体化。</p>
          <img id="trade-sec-1-cover" class="from" v-lazy="require('@/assets/home/trade-cover-1.png')" style="width: 1230px;">
        </div>
      </section>
      <section id="trade-sec-2" class="relative overflow-hidden bg-section">
        <div class="inner-container flex items-center justify-between relative">
          <div id="trade-sec-2-block-1" class="flex flex-col h-full items-center justify-center from" style="width: 670px;">
            <div class="change-container w-full overflow-hidden">
              <div class="change-scroll-list flex flex-nowrap transition ease-in-out duration-500"
                   :style="{transform: `translateX(${ tradeSwiperIndex * -670 }px)`}">
                <div v-for="(item, index) in tradeSwiperList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                     :class="{'opacity-100': tradeSwiperIndex === index}"
                     :key="index" style="width:670px;height: 560px;">
                  <img :src="item.cover"
                       class="w-full h-full"
                       style="object-fit: contain;">
                </div>
              </div>
            </div>
            <div class="flex mt-8 tab">
              <div v-for="(item, index) in tradeSwiperList" :key="index"
                   class="px-4 py-2.5 bg-white rounded-full mr-4 cursor-pointer tab-item"
                   :class="{'current': index === tradeSwiperIndex}"
                   @click="tradeSwiperIndex = index">{{ item.title }}</div>
            </div>
          </div>
          <div style="width: 614px;">
            <h3 id="trade-sec-2-title" class="heading-2 from">数字交易-<span class="red-text">中药材数字交易平台</span></h3>
            <p id="trade-sec-2-desc" class="desc my-6 from">中药材数字交易平台是面向中药材产业链上的种植、流通、加工等环节用户，以“统一标准、统一植保、统一加工、统一检测、统一认证、统一溯源、统一包装、集中仓储、集中供应”的“七统一两集中”创新管理 模式，构建中药原料贸易服务的S2B电子商务平台。解决交易模式落后、交易形式传统、交易信息闭塞、 交易数据缺失等问题，通过整合中药材种植、加工、检测、仓储、物流、交易等环节，降低中药材产业链运营成本，助力中药材产业高质量发展。</p>
            <div id="trade-sec-2-block-2" class="from">
              <h4 class="heading-2 mb-4" style="font-size: 16px;">线上：建设中药材交易数字产业平台（包括4大系统）</h4>
              <ul class="flex gap-3 flex-wrap">
                <li class="flex bg-white p-4 items-center" style="width: 48%;" v-for="(item, index) in tradeList[0]" :key="index">
                  <img style="width: 32px;height: 32px;" v-lazy="item.icon" alt="">
                  <div class="pl-4">
                    <h5 class="font-semibold" style="color: #2B2A3D;font-size: 14px;">{{item.title}}</h5>
                    <p style="font-size: 12px;color: #898893;">{{item.desc}}</p>
                  </div>
                </li>
              </ul>
            </div>
            <div id="trade-sec-2-block-3" class="from">
              <h4 class="heading-2 mb-4 mt-10" style="font-size: 16px;">线下：建设2个设配套设施</h4>
              <ul class="flex gap-3 flex-wrap">
                <li class="flex bg-white p-4 items-center" style="width: 48%;" v-for="(item, index) in tradeList[1]" :key="index">
                  <img style="width: 32px;height: 32px;" :src="item.icon" alt="">
                  <div class="pl-4">
                    <h5 class="font-semibold" style="color: #2B2A3D;font-size: 14px;">{{item.title}}</h5>
                    <p style="font-size: 12px;color: #898893;">{{item.desc}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!--    数字金融-->
    <div id="finance">
      <section id="finance-sec-1" class="relative overflow-hidden bg-section">
        <div class="inner-container flex items-center">
          <div class="flex-1 pr-10 ">
            <h3 id="finance-sec-1-title" class="heading-2 from" style="margin-bottom: 60px;color: white;">数字金融</h3>
            <ul id="finance-sec-1-block-1" class="from">
              <li v-for="(item, index) in financeList" :key="index" class="flex" style="margin-top: 80px;">
                <RedIcon :icon="item.icon"/>
                <div class="flex-1 pl-4">
                  <h4 class="mb-4 font-semibold" style="color: white;font-size: 20px;">{{ item.title }}</h4>
                  <p style="color: #898893;font-size: 14px;line-height: 28px;">{{ item.desc }}</p>
                </div>
              </li>
            </ul>
          </div>
          <div id="finance-sec-1-block-2" class="flex flex-col h-full items-center justify-center from" style="width: 670px;">
            <div class="change-container w-full overflow-hidden">
              <div class="change-scroll-list flex flex-nowrap transition ease-in-out duration-500"
                   :style="{transform: `translateX(${ financeSwiperIndex * -670 }px)`}">
                <div v-for="(item, index) in financeSwiperList" class="change-item flex-none opacity-0 transition duration-500 ease-in-out"
                     :class="{'opacity-100': financeSwiperIndex === index}"
                     :key="index" style="width:670px;height: 560px;">
                  <img :src="item.cover"
                       class="w-full h-full"
                       style="object-fit: contain;">
                </div>
              </div>
            </div>
            <div class="flex mt-8 tab">
              <div v-for="(item, index) in financeSwiperList" :key="index"
                   class="px-4 py-2.5 rounded-full mr-4 cursor-pointer tab-item"
                   :class="{'current': index === financeSwiperIndex}"
                   @click="financeSwiperIndex = index">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!--    数字监控-->
    <div id="monitor">
      <section id="monitor-sec-1" class="relative overflow-hidden bg-section">
        <div class="inner-container flex items-center">
          <div id="monitor-sec-1-block-1" style="width:688px;" class="from">
            <Macbook>
              <CuzSwiper :swiperPages="monitorSwiperPages"/>
            </Macbook>
          </div>
          <div class="box-border" style="padding-left: 80px;width: 610px">
            <div id="monitor-sec-1-block-2" class="from">
              <h3 class="heading-2">数字监管</h3>
              <h4 class="mt-2.5 mb-6" style="font-family: 'Alimama ShuHeiTi', Serif;color: #E93619;font-size: 20px;">中药材产业资源一幅图，中药材产业互联一张网</h4>
            </div>
            <ul id="monitor-sec-1-block-3" class="from">
              <li v-for="(item, index) in monitorList" :key="index" class="mb-8">
                <h5 class="mb-4 heading-3">{{ item.title }}</h5>
                <p style="font-size: 12px;line-height: 24px;color: #898893;">{{ item.desc }}</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <!--产业大数据-->
    <div id="data">
      <section id="data-sec-1">
        <div class="flex h-full flex-col justify-center items-center">
          <h3 id="data-sec-1-title" class="heading-1 text-center from">产业大数据及服务平台</h3>
          <p id="data-sec-1-desc" class="desc text-center my-8 from" style="width: 960px;">集群千乡万社数字化产地仓的标准化产品，开展订药园和中药材集采集供的电子化交易服务，为国家医保联采提供保障质量的药材原料，同时满足中药企业、医馆、连锁药店、煎药中心、出口等企业对高品质药材的集采需要，实现产销一体化。</p>
          <img id="data-sec-1-cover" class="from" v-lazy="require('@/assets/home/data-cover-1.png')" style="width: 980px;">
        </div>
      </section>
    </div>
    <!--    关于我们-->
    <div id="about">
      <section id="about-sec-1">
        <div class="flex h-full flex-col justify-center items-center">
          <h3 id="about-sec-1-title" class="heading-1 from">关于我们</h3>
          <p id="about-sec-1-desc" class="desc text-center my-6 from" style="width: 870px;">7S产地仓数字化管理平台，是为了积极服务中国中药协会和中国乡村发展协会联合发起“千乡万社中药材科技兴农计划”，推动在道地药材主产区建设科技领先、功能完善、与市场联结紧密的中药材数字化产地仓项目，运用区块链、云计算和大数据等信息技术与7S体系整合创新形成，集数字药园、数字工厂、数字金融、数字交易、数字监管、产业大数据于一体，是中药材产业的数字新基建，满足药农、合作社、种植企业、加工企业、交易中心、政府等主体的数字管理和运营，应用数字化技术对产业链的生产、质控、物流、金融、营销等进行数字赋能，推进中药材标准化生产和数字化协同。
            <br>通过从整个产业链角度的资源整合和价值链优化，降低整个产业的运营成本，提高整个产业的运营质量与效率，促进中药材产业的供给侧结构性改革，带动产业链整体转型升级。</p>
          <img id="about-sec-1-cover" class="from" v-lazy="require('@/assets/home/about-cover-1.png')" style="width: 1200px;">
        </div>
      </section>
      <section id="about-sec-2">
        <div class="flex flex-col items-center h-full justify-center">
          <h3 id="about-sec-2-title" class="heading-2 text-center mb-8 from">关于我们-7S中药材产地仓业务模式</h3>
          <img id="about-sec-2-cover" class="from" v-lazy="require('@/assets/home/about-cover-2.png')" style="width: 1200px;">
        </div>
      </section>
      <section id="about-sec-3" class="relative overflow-hidden bg-section">
        <div class="inner-container flex flex-col justify-center">
          <h3 id="about-sec-3-title" class="heading-2 mb-8 text-center from">关于我们-合作单位</h3>
          <ul id="about-sec-3-departments" class="flex department-list relative from">
            <li v-for="(item, index) in departmentList" :key="index"
                class="bg-white transition-all cursor-pointer flex-1 flex flex-col items-center">
              <div class="icon flex items-center justify-center">
                <img :src="item.icon">
              </div>
              <div class="title font-semibold my-4">{{ item.title }}</div>
              <div class="departments">
                <div class="department text-center" v-for="(department, departmentIndex) in item.departments" :key="departmentIndex">{{department}}</div>
              </div>
            </li>
          </ul>
        </div>
      </section>
    </div>
<!--    <button class="cooperate-button fixed flex flex-col items-center justify-center" @click="openForm">-->
<!--      <img src="@/assets/home/icon-cooperate.svg" class="mb-2">-->
<!--      <span class="text-white">合作交流</span>-->
<!--    </button>-->
<!--    <footer class="footer text-center box-border">-->
<!--      <div>备案编号: 蜀ICP备15009849号-2</div>-->
<!--    </footer>-->
    <FormModal ref="FormModalRef"/>
  </div>
</template>

<script>
import RedIcon from "../components/RedIcon.vue";
import Macbook from "../components/Macbook.vue";
import CuzSwiper from "../components/CuzSwiper.vue";
import FormModal from "../components/FormModal.vue";
import {isEmpty} from "lodash";
import Banner from "./Banner.vue";

function animationBase(parentName, children = ['title', 'cover', 'desc']) {
  children.forEach(child => {
    const target = document.querySelector(`#${parentName}-${child}`);
    if(!isEmpty(target)) {
      target.classList.remove('from');
    }
  })
}

export default {
  name: 'HomeView',
  components: {Banner, FormModal, CuzSwiper, Macbook, RedIcon},
  data() {
    return {
      menuIndex: 0,
      menu: [
        {
          label: '首页',
          id: '',
        },
        {
          label: '数字药园',
          id: 'park',
        },
        {
          label: '数字工厂',
          id: 'factory',
        },
        {
          label: '数字交易',
          id: 'trade',
        },
        {
          label: '数字金融',
          id: 'finance',
        },
        {
          label: '数字监控',
          id: 'monitor',
        },
        {
          label: '产业大数据',
          id: 'data',
        },
        {
          label: '关于我们',
          id: 'about',
        },
      ],
      scrollEL: null,
      currentParkIndex: 0,
      parkList: [
        {
          title: '中药材种植模型构建',
          desc: '首先基于7S体系多年的基础研究和应用，获得的大量基础数据，结合中药材长势、质量等产出数据，形成中药材的“生长模型”，再通过深化分析、优化，形成评估指标和算法模型，构建出中药材“种植模型”。',
          cover: require('@/assets/home/park-list-cover-1.png'),
        },
        {
          title: '中药材数字基地建设',
          desc: '通过3S（GPS、GIS和RS）、物联网、自动化技术，实现基地温光水肥土等生产要素的数字化；通过管理标准化，实现农事记录、投入品定时、定位、定量管理，以高新技术投入和科学管理换取对自然资源的最大节约和对农业产出的最大索取。',
          cover: require('@/assets/home/park-list-cover-2.png'),
        },
        {
          title: '中药材种植数字化管理',
          desc: '通过中药材种植数字化管理APP（管农事）和数字基地可视化管理（管基地）平台对中药材基地进行数字化管理。基于种植模型为基地管理人员提供种植预警和管护建议，实现种植基地的绿色标准化流程作业。',
          cover: require('@/assets/home/park-list-cover-1.png'),
        },
      ],
      factorySwiperPages: [
        {
          image: require('@/assets/home/factory-swiper-1.png')
        },
        {
          image: require('@/assets/home/factory-swiper-2.png')
        },
        {
          image: require('@/assets/home/factory-swiper-3.png')
        },
        {
          image: require('@/assets/home/factory-swiper-4.png')
        }
      ],
      factoryList: [
        {
          icon: 'factory-icon-1.svg',
          title: '数字生产线',
          desc: '对产地趁鲜加工和产地精深加工的生产线的设备进行三维建模，并结合生产工艺对产品生产加工流程进行体系化呈现，对生产车间进行实时视频监控，对生产排产等关键指标进行数据统计和实时监控。',
        },
        {
          icon: 'factory-icon-2.svg',
          title: '产品追溯实时监测',
          desc: '对加工产品进行实时监控，统计溯源产品数量、扫码追溯记录等详细数据，并结合企业的产品销售数据，对产品流向、销售热区等进行实时统计和分析，为企业产品销售、质量管控提供数智化管理手段。',
        }
      ],
      tradeSwiperIndex: 0,
      tradeSwiperList: [
        {
          title: '数字交易平台',
          cover: require('@/assets/home/trade-swiper-1.png'),
        },
        {
          title: '交易平台小程序',
          cover: require('@/assets/home/trade-swiper-2.png'),
        }
      ],
      tradeList: [
        [
          {
            icon: require('@/assets/home/trade-icon-1.svg'),
            title: '中药材数字交易系统',
            desc: 'B2B大宗电子交易',
          },
          {
            icon: require('@/assets/home/trade-icon-2.svg'),
            title: '中药材合同订单管理系统',
            desc: '订单、合同、结算',
          },
          {
            icon: require('@/assets/home/trade-icon-3.svg'),
            title: '中药材运营管理系统',
            desc: '追溯、检测、资金等服务和运营管理',
          },
          {
            icon: require('@/assets/home/trade-icon-4.svg'),
            title: '中药材数字仓储系统',
            desc: '仓储配送一体化',
          },
        ],
        [
          {
            icon: require('@/assets/home/trade-icon-5.svg'),
            title: '中药材交易服务中心',
            desc: '展示、交易、服务',
          },
          {
            icon: require('@/assets/home/trade-icon-6.svg'),
            title: '中药材交易数字监管仓',
            desc: '包装、仓储、配送',
          },
        ],
      ],
      financeList: [
        {
          icon: 'finance-icon-1.svg',
          title: '数字监管仓',
          desc: '数字监管仓内安装环境监控、视频监控等物联网设备，对中药材进行标准化仓储管理并形成标准仓单，中药材仓单质押贷业务基于标准仓单开展，为抵押者提供融资服务。'
        },
        {
          icon: 'finance-icon-2.svg',
          title: '中药材仓单质押贷款',
          desc: '中药材仓单质押贷款是一种短期融资业务，中药材产业经营主体可以用中药材干品（如三七剪口、三七统货等）质押来获得贷款的一种方式。'
        },
      ],
      financeSwiperIndex: 0,
      financeSwiperList: [
        {
          title: '数字监管仓',
          cover: require('@/assets/home/finance-swiper-1.png'),
        },
        {
          title: '中药材仓单质押贷',
          cover: require('@/assets/home/finance-swiper-2.png'),
        }
      ],
      monitorList: [
        {
          title: '中药材产业数据可视化平台',
          desc: '通过在地图上进行定位和展示的方式，打破时间、空间的限制，多方位、多角度、多维度地可视化展示中药材产业发展情况，构建“中药材产业资源一幅图”集成展示新平台，增强道地药材的知名度。',
        },
        {
          title: '中药材数字化监管平台',
          desc: '建立较为完善的数字化管理机制和运行机制，针对中药材标准化生产、产品溯源、农业投入品、产地加工、销售等环节进行重点监管。',
        },
        {
          title: '中药材产业服务平台',
          desc: '以共享经济模式汇聚科技、物流、金融、营销等产业服务资源，对全产业链企业进行数字赋能，围绕中药材绿色标准化生产，提供重点品种价格监测，中药材产业内参等中药材资讯服务，提供产地趁鲜加工、产地精深加工、中药材专用农资、中药材仓单质押贷等中药材产地服务，形成“中药材产业互联一张网”带动产业链整体转型升级。实现种植基地的绿色标准化流程作业。',
        },
      ],
      monitorSwiperPages: [
        {
          image: require('@/assets/home/monitor-swiper-1.png')
        },
        // {
        //   image: require('@/assets/home/monitor-swiper-3.png')
        // },
        {
          image: require('@/assets/home/monitor-swiper-2.png')
        }
      ],
      departmentList: [
        {
          icon: require('@/assets/home/about-icon-1.svg'),
          title: '组织机构',
          departments: [
            '现代中药资源动态监测信息和技术服务中心',
            '中国中药协会中药材检测认证技术专业委员会'
          ]
        },
        {
          icon: require('@/assets/home/about-icon-2.svg'),
          title: '支持单位',
          departments: [
            '中国中药协会',
            '中国中医科学院中药资源中心',
            '中国药用植物研究所',
            '国家认监委认证认可技术研究所',
            '成都中医药大学',
            '解放军302医院全军中医药研究所',
            '中健安检测认证中心',
          ]
        },
        {
          icon: require('@/assets/home/about-icon-3.svg'),
          title: '技术服务',
          departments: [
            '7S技术服务中心',
            '四川华邑检测认证服务有限公司',
            '云南唯恒基业科技有限公司',
          ]
        },
      ],
    }
  },
  methods: {
    scrollToSec({id}, index) {
      let top = 0
      if(!isEmpty(id)){
        const target = document.querySelector(`#${id}`)
        top = target.offsetTop - 120
      }
      window.scrollTo({
        top,
        behavior: 'smooth'
      })
    },
    openForm() {
      this.$refs.FormModalRef.open();
    },
    sceneBuilder(trigger, menuIndex, children, duration = 820) {
      const scene = this.$scrollmagic.scene({
        triggerElement: `#${trigger}`,
        duration,
      })
        .on('start', () => {
          animationBase(trigger, children);
        })
        .on('progress', () => {
          this.menuIndex = menuIndex;
        });
      // if(process.env.NODE_ENV === 'development') {
      //   scene.addIndicators({
      //     name: trigger
      //   });
      // }
      this.$scrollmagic.addScene(scene);
    },
    sceneAbout() {
      this.sceneBuilder('about-sec-1', 7, ['cover', 'title', 'desc']);
      this.sceneBuilder('about-sec-2', 7, ['cover', 'title']);
      this.sceneBuilder('about-sec-3', 7, ['title', 'departments']);
    },
    sceneMonitor() {
      this.sceneBuilder('monitor-sec-1', 5, ['block-1', 'block-2', 'block-3']);
    },
    sceneData() {
      this.sceneBuilder('data-sec-1', 6, ['cover', 'title', 'desc']);
    },
    sceneTrade() {
      this.sceneBuilder('trade-sec-1', 3, ['cover', 'title', 'desc']);
      this.sceneBuilder('trade-sec-2', 3, ['title', 'desc', 'block-1', 'block-2', 'block-3']);
    },
    sceneFinance() {
      this.sceneBuilder('finance-sec-1', 4, ['block-1', 'block-2', 'title']);
    },
    sceneFactory() {
      this.sceneBuilder('factory-sec-1', 2, ['block-1', 'block-2', 'block-3']);
    },
    scenePark() {
      this.sceneBuilder('park-sec-1', 1, ['title', 'block-1', 'block-2']);
      this.sceneBuilder('park-sec-2', 1, ['cover', 'title']);
      this.sceneBuilder('park-sec-3', 1, ['cover', 'title', 'desc']);
    },
    sceneHome() {
      this.sceneBuilder('home-sec-1', 0, ['cover', 'title', 'desc', 'tags']);
      this.sceneBuilder('home-sec-2', 0, ['cover', 'title']);
    },
    init() {
      this.$scrollmagic.attachTo(document.querySelector('.scroll-wrapper'), {});
      this.sceneHome();
      this.scenePark();
      this.sceneFactory();
      this.sceneTrade();
      this.sceneFinance();
      this.sceneData();
      this.sceneMonitor();
      this.sceneAbout();
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
.page{
  width: 100%;
  padding-top: 120px;
  overflow-x: hidden;
}
.inner-container{
  width: 1366px;
  @apply h-full mx-auto;
}
.header{
  height: 120px;
  position: fixed;
  width: 100%;
  top: 0;
  max-width: 100vw;
  z-index: 9;
  nav{
    .nav-item{
      height: 24px;
      position: relative;
      transition: all .15s;
      &:after{
        content: '';
        display: block;
        position: absolute;
        background: #E84E4E;
        width: 0;
        height: 2px;
        left: 50%;
        bottom: 0;
        transition: all .15s;
      }
      &.current{
        height: 32px;
        color: #E84E4E;
        &:after{
          width: 100%;
          left: 0;
        }
      }
    }
  }
}
.footer{
  height: 180px;
  padding-top: 40px;
  font-size: 14px;
  color: #898893;
}
.banner{
  height: 650px;
}
.heading-1,
.heading-2{
  font-family: "Alimama ShuHeiTi", serif;
  font-weight: 700;
  color: #2B2A3D;
  .red-text{
    color: #E84E4E;
  }
}
.heading-1{
  font-size: 36px;
}
.heading-2{
  font-size: 28px;
}
.heading-3{
  font-weight: 700;
  color: #2B2A3D;
  font-size: 20px;
}
.desc{
  font-size: 16px;
  line-height: 28px;
  color: #898893;
}
.alt{
  font-size: 14px;
  line-height: 24px;
}
.cooperate-button{
  top: 50%;
  transform: translateY(-50%);
  right: 0;
  width: 88px;
  height: 88px;
  background: #E84E4E;
  box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
  border-radius: 4px 0px 0px 4px;
  span{
    font-size: 12px;
  }
}
section{
  height: 820px;
  overflow: hidden;
}
.bg-section{
  background: var(--bg);
  &:before,
  &:after{
    content: '';
    display: block;
    position: absolute;
    border-radius: 50%;
    filter: blur(17px);
  }
  &:before{
    width: var(--ball-1-sz);
    height: var(--ball-1-sz);
    background: var(--ball-1-bg);
    opacity: var(--ball-1-op);
    left: var(--ball-1-lt);
    top: var(--ball-1-tp);
    right: var(--ball-1-rt);
    bottom: var(--ball-1-bt);
  }
  &:after{
    width: var(--ball-2-sz);
    height: var(--ball-2-sz);
    background: var(--ball-2-bg);
    opacity: var(--ball-2-op);
    left: var(--ball-2-lt);
    top: var(--ball-2-tp);
    right: var(--ball-2-rt);
    bottom: var(--ball-2-bt);
  }
}
#home{
  #home-sec-1{
    .cover{
      width: 600px;
      height: 390px;
      border-radius: 16px;
      box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
    }
    .info{
      height: 390px;
      .tag-list{
        li{
          & + li{
            margin-left: 80px;
          }
        }
      }
    }
    #home-sec-1-cover{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    #home-sec-1-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    #home-sec-1-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    #home-sec-1-tags{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
  }
  #home-sec-2{
    background: #F9F9F9;
    #home-sec-2-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    #home-sec-2-cover{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#park{
  #park-sec-1{
    .park-list{
      width: 658px;
      li{
        border-radius: 12px;
        transition: box-shadow .15s ease 0s;
        h4{
          color: #2B2A3D;
          font-weight: 700;
          font-size: 20px;
        }
        &.current,
        &:hover{
          box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
          h4{
            color: #E84E4E;
          }
        }
      }
    }
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(-300px);
        opacity: 0;
      }
    }
    &-block-1{
      li{
        will-change: opacity, transform, box-shadow;
        &:nth-child(1){
          transition: opacity .5s ease .3s, transform .5s ease .3s;
        }
        &:nth-child(2){
          transition: opacity .5s ease .5s, transform .5s ease .5s;
          transition-delay: .5s;
        }
        &:nth-child(3){
          transition: opacity .5s ease .7s, transform .5s ease .7s;
        }
      }
      &.from{
        li{
          transform: translateX(-300px);
          opacity: 0;
        }
      }
    }
    &-block-2{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
  }
  #park-sec-2{
    background: #F9F9F9;
    #park-sec-2-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    #park-sec-2-cover{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
  #park-sec-3{
    --bg: #272727;
    --ball-1-sz: 860px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, #DE5F4C 0%, #DE4CA4 0.01%, rgba(222, 76, 207, 0) 100%);
    --ball-1-op: 0.38;
    --ball-1-lt: -180px;
    --ball-1-tp: -282px;
    --ball-2-sz: 620px;
    --ball-2-bg: radial-gradient(50% 50% at 50% 50%, #DE5F4C 0%, rgba(222, 95, 76, 0.19) 100%);
    --ball-2-op: 0.2;
    --ball-2-rt: -85px;
    --ball-2-bt: -85px;
    h3{
      color: white;
    }
    .desc{
      color: #898893;
      width: 800px;
    }
    #park-sec-3-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    #park-sec-3-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    #park-sec-3-cover{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#factory{
  #factory-sec-1{
    --bg: #F9F9F9;
    --ball-1-sz: 1094px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, #4C98DE 0%, rgba(76, 222, 222, 0.19) 100%);
    --ball-1-op: 0.2;
    --ball-1-lt: -140px;
    --ball-1-bt: -500px;
    --ball-2-sz: 860px;
    --ball-2-bg: radial-gradient(50% 50% at 50% 50%, #4CB2DE 0%, rgba(210, 250, 255, 0) 100%);
    --ball-2-op: 0.38;
    --ball-2-tp: -280px;
    --ball-2-rt: -85px;
    .factory-list{
      li{
        & + li{
          margin-top: 34px;
        }
        h4{
          font-weight: 700;
          font-size: 20px;
          color: #2B2A3D;
        }
        p{
          font-size: 14px;
          line-height: 28px;
          color: #898893;
        }
      }
    }
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-block-3{
      li{
        transition: .5s ease;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
      }
      &.from{
        li{
          transform: translateX(300px);
          opacity: 0;
        }
      }
    }
  }
}
#trade{
  #trade-sec-1{
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-cover{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
  #trade-sec-2{
    --bg: #F9F9F9;
    --ball-1-sz: 860px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, #DE5F4C 0%, rgba(222, 76, 164, 0.52) 0.01%, rgba(222, 76, 207, 0) 100%);
    --ball-1-op: 0.38;
    --ball-1-lt: -180px;
    --ball-1-bt: -280px;
    --ball-2-sz: 620px;
    --ball-2-bg: radial-gradient(50% 50% at 50% 50%, #CBE9AE 0%, #F2FEE6 100%);
    --ball-2-op: 0.2;
    --ball-2-bt: -250px;
    --ball-2-rt: -80px;
    .tab{
      .tab-item{
        transition: .15s ease;
        &.current{
          color: #E84E4E;
          box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
        }
      }
    }
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-block-3{
      transition: .5s ease .7s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
  }
}
#finance{
  #finance-sec-1{
    --bg: #212523;
    --ball-1-sz: 860px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, rgba(23, 163, 101, 0.42) 0%, rgba(221, 229, 172, 0) 100%);
    --ball-1-op: 0.38;
    --ball-1-lt: -180px;
    --ball-1-bt: -280px;
    .tab{
      .tab-item{
        transition: .15s ease;
        background: rgba(255, 255, 255, 0.24);
        color: white;
        &.current{
          background-color: white;
          color: #E84E4E;
          box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
        }
      }
    }
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-block-1{
      li{
        transition: .5s ease;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
      }
      &.from{
        li{
          transform: translateY(300px);
          opacity: 0;
        }
      }
    }
  }
}
#data{
  #data-sec-1{
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-cover{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
}
#monitor{
  #monitor-sec-1{
    --bg: #F9F9F9;
    --ball-1-sz: 860px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, #DE5F4C 0%, rgba(222, 76, 164, 0.52) 0.01%, rgba(222, 76, 207, 0) 100%);
    --ball-1-op: 0.38;
    --ball-1-lt: -180px;
    --ball-1-bt: -280px;
    --ball-2-sz: 620px;
    --ball-2-bg: radial-gradient(50% 50% at 50% 50%, #CBE9AE 0%, #F2FEE6 100%);
    --ball-2-op: 0.2;
    --ball-2-bt: -250px;
    --ball-2-rt: -80px;
    &-block-1{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    &-block-2{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
    &-block-3{
      li{
        transition: .5s ease;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
        &:nth-child(3){
          transition: .5s ease .7s;
        }
      }
      &.from{
        li{
          transform: translateY(300px);
          opacity: 0;
        }
      }
    }
  }
}
#about{
  #about-sec-1{
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-desc{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-cover{
      transition: .5s ease .5s;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
  }
  #about-sec-2{
    background: #F9F9F9;
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateX(-300px);
        opacity: 0;
      }
    }
    &-cover{
      transition: .5s ease .3s;
      will-change: opacity, transform;
      &.from{
        transform: translateX(300px);
        opacity: 0;
      }
    }
  }
  #about-sec-3{
    --bg: #EFEFEF;
    --ball-1-sz: 860px;
    --ball-1-bg: radial-gradient(50% 50% at 50% 50%, rgba(48, 211, 253, 0.28) 0%, #FFFFFF 94.27%);
    --ball-1-op: 0.38;
    --ball-1-lt: -180px;
    --ball-1-bt: -280px;
    --ball-2-sz: 620px;
    --ball-2-bg: radial-gradient(50% 50% at 50% 50%, #CBE9AE 0%, #F2FEE6 100%);
    --ball-2-op: 0.2;
    --ball-2-bt: -280px;
    --ball-2-rt: -80px;
    background: #EFEFEF;
    .department-list{
      gap: 40px;
      li{
        border-radius: 12px;
        height: 470px;
        padding: 72px 0 0;
        &:hover{
          box-shadow: 7px 11px 43px rgba(0, 0, 0, 0.1);
        }
        .icon{
          width: 92px;
          height: 92px;
          border-radius: 24px;
          background: #E84E4E;
        }
        .title{
          font-size: 20px;
          color: #2B2A3D;
        }
        .departments{
          color: #898893;
          line-height: 26px;
          font-size: 14px;
        }
      }
    }
    &-title{
      transition: .5s ease;
      will-change: opacity, transform;
      &.from{
        transform: translateY(300px);
        opacity: 0;
      }
    }
    &-departments{
      li{
        transition: .5s ease;
        will-change: opacity, transform;
        &:nth-child(1){
          transition: .5s ease .3s;
        }
        &:nth-child(2){
          transition: .5s ease .5s;
        }
        &:nth-child(3){
          transition: .5s ease .7s;
        }
      }
      &.from{
        li{
          opacity: 0;
          transform: translateY(300px);
        }
      }
    }
  }
}
</style>
